import { Box, Button, Flex, Heading, HStack, Image, Spinner, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { OrderSection } from 'pages/dashboard/components/DashboardStyles';
import { backbtn } from 'pages/dashboard/components/Icons';
import emptyList from 'assets/empty-list.png';
import cartSvg from 'assets/shopping-cart.svg';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromStoreCart } from 'utils/utils';
import StoreCartItem from 'components/Store/StoreCartItem';
import { updateStoreCart } from 'redux/actions/storefrontActions';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

const StoreCart = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { cart, storefrontData } = useSelector((state) => state.storefrontReducer);

    const deleteFromCart = (item) => {
        dispatch(updateStoreCart(removeFromStoreCart(cart, item)));
    };

    const total = cart?.length > 0 ? cart?.reduce((a, b) => a + Number(b.price * b?.qty), 0) : 0;
    return (
        <>
            {cart ? (
                <OrderSection>
                    {cart?.length === 0 ? (
                        <Box position="relative">
                            <HStack justify="space-between" px="27px" mt="15px" alignItems="center">
                                <Heading
                                    as="h2"
                                    textAlign="center"
                                    color="#090A0A"
                                    fontSize="xl"
                                    lineHeight="36px"
                                    cursor="pointer"
                                    _hover={{ color: 'blue' }}
                                    onClick={() => navigate(`/store/${storefrontData.name}`)}>
                                    &larr; Go to Store
                                </Heading>
                                <Heading
                                    textAlign="center"
                                    color="#090A0A"
                                    fontSize="32px"
                                    lineHeight="36px">
                                    My Cart
                                </Heading>
                                <Button
                                    color="#F5F5F5"
                                    bg="transparent"
                                    mt="15px"
                                    fontWeight="400"
                                    borderRadius="48px"
                                    h="32px"
                                    w="43px"
                                    outline="none"
                                    onClick={() => {
                                        navigate('/dashboard/categories');
                                    }}>
                                    &nbsp;
                                </Button>
                            </HStack>

                            <VStack h="55vh" justify="center">
                                <Image src={emptyList} />
                                <Text
                                    w="200px"
                                    textAlign="center"
                                    fontWeight="600"
                                    fontSize="17px"
                                    lineHeight="16px"
                                    pt="27px">
                                    You have not added any Product to My Cart
                                </Text>
                            </VStack>
                        </Box>
                    ) : (
                        <Box
                            position="relative"
                            pb="20px"
                            w={{ base: 'full', lg: '95%' }}
                            mx="auto">
                            <HStack
                                justify="space-between"
                                alignItems="center"
                                mt="27px"
                                w={{ base: '90vw', lg: '98%' }}
                                mx="auto">
                                <Box
                                    display={{ base: 'flex', lg: 'none' }}
                                    onClick={() => navigate(-1)}>
                                    {backbtn}
                                </Box>
                                <Box
                                    display={{ base: 'block', lg: 'flex' }}
                                    alignItems="center"
                                    gap="10rem">
                                    <Flex gap="5px" justify="center">
                                        <Heading
                                            as="h2"
                                            textAlign="center"
                                            color="#090A0A"
                                            fontSize={{ base: '22px', lg: '32px' }}
                                            lineHeight="36px">
                                            My Cart
                                        </Heading>
                                        <Image src={cartSvg} />
                                    </Flex>
                                    <Text>
                                        {cart?.length} items - Total{' '}
                                        <WalletHistoryPrice price={total} />
                                    </Text>
                                </Box>
                                <div></div>
                            </HStack>
                            <Flex
                                flexDir={{ base: 'column', lg: 'row' }}
                                w={{ base: 'full', lg: '95%' }}
                                mx="auto"
                                gap={{ base: '0', lg: '5rem' }}>
                                <VStack
                                    h="max-content"
                                    w={{ base: 'full', lg: '40%' }}
                                    gap={{ base: 0, lg: '1.3rem' }}
                                    mb="4rem">
                                    {cart ? (
                                        cart.map((li) => (
                                            <StoreCartItem
                                                item={li}
                                                key={li.id}
                                                deleteFromCart={deleteFromCart}
                                            />
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                </VStack>
                                <Box w={{ base: 'full', lg: '50%' }} mt={{ lg: '3rem', base: 0 }}>
                                    <VStack
                                        w={{ base: '80%', lg: '90%' }}
                                        mx="auto"
                                        alignItems="start">
                                        <Heading
                                            fontSize="15px"
                                            lineHeight="32px"
                                            pb="5px"
                                            w="full"
                                            mb="10px"
                                            borderBottom="1px solid #0000001a">
                                            Total
                                        </Heading>
                                        <Flex justifyContent="space-between" w="full">
                                            {' '}
                                            <Text fontSize="13px" fontWeight="700">
                                                Sub-total
                                            </Text>
                                            <Text fontSize="18px" fontWeight="700">
                                                <WalletHistoryPrice price={total} />
                                            </Text>
                                        </Flex>
                                    </VStack>
                                    <Box w="90%" mx="auto" mb="2rem">
                                        <Button
                                            color="#F5F5F5"
                                            bg="#1b3b5f"
                                            mt="15px"
                                            fontWeight="400"
                                            borderRadius={{ base: '48px', lg: '0' }}
                                            h="48px"
                                            w="full"
                                            mx="auto"
                                            outline="none"
                                            _hover={{
                                                fontWeight: '500',
                                                textDecoration: 'underline',
                                            }}
                                            onClick={() => navigate(`/dashboard/checkout/2`)}>
                                            Checkout
                                        </Button>
                                    </Box>
                                    <Flex justifyContent="flex-end">
                                        <Button
                                            color="#F5F5F5"
                                            bg="#1b3b5f"
                                            mt="15px"
                                            fontWeight="400"
                                            borderRadius={{ base: '48px', lg: '0' }}
                                            h="48px"
                                            outline="none"
                                            _hover={{
                                                fontWeight: '500',
                                            }}
                                            onClick={() =>
                                                navigate(`/store/${storefrontData.name}`)
                                            }>
                                            Continue Shopping
                                        </Button>
                                    </Flex>
                                </Box>
                            </Flex>
                        </Box>
                    )}
                </OrderSection>
            ) : (
                <Spinner size="xl" />
            )}
        </>
    );
};

export default StoreCart;
